import {
  Alert,
  Box,
  Collapse,
  Grid,
  MenuItem,
  Typography,
} from '@mui/material';
import React, { Dispatch } from 'react';
import {
  staticContractObjectSubtypeArray,
  staticContractObjectTypeArray,
} from '../../../../../Interfaces/IContractObjectType';
import { ISignatureCertificationRelationshipData } from '../../../../../Interfaces/ILegalTransactionRelationship/Relationships/SignatureCertification/ILegalTransactionRelationshipSignatureCertificationData';
import { CustomeTextField } from '../../../../generic/CustomeTextField';
import { NavRow } from '../../generic/NavRow';

interface IProps {
  scObject: ISignatureCertificationRelationshipData;
  setScObject: Dispatch<
    React.SetStateAction<ISignatureCertificationRelationshipData>
  >;
  handleNext: () => void;
  handleBack: () => void;
}

export const SignatureCertificationEditContractType: React.FC<IProps> = ({
  scObject,
  setScObject,
  handleNext,
  handleBack,
}) => {
  const isFreeText = staticContractObjectSubtypeArray.find(
    x => x.idContactObjectSubtype === scObject.idContactObjectSubtype
  )?.allowFreeText;

  const onSubmit = () => {
    handleNext();
  };

  const disableNext =
    scObject.idContractObjectType === null ||
    scObject.idContactObjectSubtype === null ||
    (isFreeText && scObject.textcontactObjectSubtype === null);

  return (
    <Box>
      <Box sx={{ mt: 5 }} />
      <Typography variant='h4'>Gegenstand</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity='info'>
            Um welche Art von Vertrag handelt es sich?
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <CustomeTextField // TODO: get rid of this
            attr='idContractObjectType'
            label='Vertragsart'
            object={scObject}
            setObject={setScObject}
            type='select'
            required
            null
          >
            {staticContractObjectTypeArray.map(contractType => (
              <MenuItem
                key={`contracttype-${contractType.idContractObjectType}`}
                value={contractType.idContractObjectType}
              >
                {contractType.contractObjectType}
              </MenuItem>
            ))}
          </CustomeTextField>
        </Grid>
        <Grid item xs={12}>
          <Collapse
            in={
              scObject.idContractObjectType !== null &&
              scObject.idContractObjectType > 0
            }
          >
            <CustomeTextField
              attr='idContactObjectSubtype'
              label='Vertragsinhalt'
              object={scObject}
              setObject={setScObject}
              type='select'
              required
              null
            >
              {staticContractObjectSubtypeArray
                .filter(
                  x => x.idContractObjectType === scObject.idContractObjectType
                )
                .map(contractType => (
                  <MenuItem
                    key={`contractsubtype-${contractType.idContactObjectSubtype}`}
                    value={contractType.idContactObjectSubtype}
                  >
                    {contractType.contactObjectSubtype}
                  </MenuItem>
                ))}
            </CustomeTextField>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <Collapse in={isFreeText}>
            <CustomeTextField
              attr='textcontactObjectSubtype'
              label='Vertragsinhalt'
              object={scObject}
              setObject={setScObject}
              type='string'
              required={isFreeText}
              rows={2}
            />
          </Collapse>
        </Grid>
      </Grid>

      <NavRow
        handleBack={handleBack}
        handleNext={onSubmit}
        disableNext={disableNext}
      />
    </Box>
  );
};
